module.exports = "/images/withOutOrders.svg";